import React, { Fragment } from 'react';
import { Parallax } from 'react-scroll-parallax';
import Showcase from '../common/Showcase';
import { ReactSVG } from 'react-svg';
import Media from 'react-media';
import { MOBILE_WIDTH } from '../../constants';
import rightTriangle from '../../assets/shapes/rightTriangle.svg';
import ringPat from '../../assets/shapes/ringPat.svg';
import circle from '../../assets/shapes/circle.svg';
import imageSource from '../../assets/screenshots/7-invoice.png';

import styles from './MotivationalFeeInvoice.module.scss';
const motivationalFeeInvoice = {
	title: 'Motivational Fees',
	content:
		"When your reflection date comes around (weekly by default) you'll be presented with a motivational fee invoice where we will settle up in the areas that we fell short.",
	featureTitle: 'Features',
	features: [
		'Motivational Fees (similar to the ones popular workout classes and gyms use to get you to show up)',
		'Behavioral science has shown we are much more motivated by immediate consequences than by future possibilities.',
		'We are going to use that as a tool to help us get the things that we want.',
	],
	imageSource,
};
const { centerCluster, centerStyle, center, centerSM, border, ringStyle, circleStyle, shapeCluster, lead, middle, trail, motivationalContainer } =
	styles;

const MotivationalFeeInvoice = (props) => {
	return (
		<Fragment>
			<Media query={{ maxWidth: MOBILE_WIDTH }}>
				{(matches) => (
					<Showcase item={motivationalFeeInvoice} bubbleStyle={border} containerClass={`${matches ? motivationalContainer : null}`}>
						<div className={shapeCluster}>
							<ReactSVG src={circle} className={circleStyle} />

							<Parallax translateY={[300, -73]} className={ringStyle}>
								<ReactSVG src={ringPat} />
							</Parallax>
						</div>
						<div className={centerCluster}>
							<Parallax translateY={[0, -75]} className={centerStyle}>
								<ReactSVG src={rightTriangle} className={`${matches ? centerSM : center}`} />
							</Parallax>
						</div>
					</Showcase>
				)}
			</Media>
		</Fragment>
	);
};

export default MotivationalFeeInvoice;
